import React, { useState, useEffect, useContext, useRef,} from 'react';
import './index.scss';
import { Table, Input, Form, Typography, Button, Modal, Row, Col } from 'antd';
// const { TextArea } = Input;
// const { Panel } = Collapse;
const { Text } = Typography;


const EditableContext = React.createContext(null);

const EditableDetailRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const IEDetailsModal = (props) => {
  const { 
    itemRecord, 
    visible, 
    handleCancel, 
    onCopyToMyModifier,
    detailData,
    handleOkActivity,
    handleSave,
    // handleAddInsightsActivity,
    isAddActivity } = props; 
    const modifierError = useRef(false);
    const EditableDetailCell = ({
        title,
        editable,
        children,
        dataIndex,
        record,
        handleSave,
        ...restProps
      }) => {
        const [editing, setEditing] = useState(false);
        const inputRef = useRef(null);
        const form = useContext(EditableContext);
        useEffect(() => {
          if (editing) {
            inputRef.current.focus();
          }
        }, [editing]);
       
        const toggleEdit = () => {  
          if (!modifierError.current) {  
            setEditing(!editing);  
            form.setFieldsValue({ [dataIndex]: record[dataIndex] });  
          }  
        }; 

        const save = async () => {
          try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
              ...record,
              ...values,
            });
            modifierError.current = false;
          } catch (errInfo) {
            console.log('Save failed:', errInfo);
            modifierError.current = true;
            setEditing(true)
          }
        };
        let childNode = children;
        if (editable) {
          childNode = editing ? (
            <Form.Item
              style={{
                // margin: 0,
              }}
              name={dataIndex}
              rules={[
                {
                  max: 500,
                  message: 'My modifiers should be within 500 characters',
                  // required: true,
                  // message: `${title} is required.`,
                },
              ]}
            >
              <Input 
              ref={inputRef} 
              onPressEnter={save} 
              onBlur={save} 
              style={{ width: "300px", fontSize: 14}} />
            </Form.Item>
          ) : (
            <div
              className="detail-cell-value-wrap"
              style={{
                paddingRight: 24,
              }}
              onClick={toggleEdit}
              onFocus={toggleEdit}
            >
              {children}
            </div>
          );
        }
        return <td {...restProps}>{childNode}</td>;
    };

    const detailColumns =  [{
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: 200,
        },
        {
        title: 'History',
        dataIndex: 'history',
        key: 'history',
        width: 320,
        },
        {
        title: 'Modifiers',
        dataIndex: 'modifiers',
        key: 'modifiers',
        width: 320,
        editable: true,
        render: (_, record) => {
            return <Input style={{ width: "300px", fontSize: 14}} value={record['modifiers']}/>
        }
    },]

    const newDetailColumns = detailColumns.map((col) => {
    if (!col.editable) {
        return col;
    }
    return {
        ...col,
        onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        }),
    };
    });

    // const insightsModifierChange = (e, itemRecord) => {
    //   handleAddInsightsActivity(e, itemRecord)
    // }
    const handleSubmitActivity = (e, itemRecord) => {
     if(modifierError.current){
        return;
      }
      handleOkActivity(e, itemRecord);
    };
    const handleNewCancel = () =>{
      if(modifierError.current){
        modifierError.current = false;
      }
      handleCancel();
    }

    return ( 
    <Modal 
        visible={visible} 
        title="" 
        closable={false} 
        mask={false}
        onCancel={handleCancel} 
        footer={null} 
        style={{ top:10 }} 
        centered={false} 
        maskClosable={false}
        wrapClassName="criteriaDetailModal"
    >
        <Row className="ie-configure-title">
        <span>Additional details</span>
        </Row>
        {/* <br/> */}
        <Row className="endpoint-modal-filed">
        <Col span={24} className="informed-consent-label">
            <Text
            ellipsis={true}
            >
             {isAddActivity ?  itemRecord['Text'] : itemRecord['Eligibility Criteria']} 
            </Text>
        </Col>
        <Col span={24} className="procedure-label">
        <Text
            ellipsis={true}
            >
                {itemRecord['criteria_category']}
            </Text>
        </Col>
        <Col span={24}><span><br /></span></Col>
        
        <Col span={8} className="label-header"><span>Entity frequency </span></Col>
        <Col span={8} className="label-header"><span>Number of amendments </span></Col>
        <Col span={8} className="label-header"><span>Screen failure rate</span></Col>  
        <Col span={8} className="label-values"> 
        { Math.round(itemRecord['Frequency'] * 10000) / 100 + "%"}
        </Col>
        <Col span={8} className="label-values">
            <span>
            {isAddActivity 
              ? (itemRecord['details']&&itemRecord['details']['number_of_amendments'])||"NA" 
              : (itemRecord['Detail']&&itemRecord['Detail']['number_of_amendments'])||"NA"}
            
            </span>
        </Col>
        <Col span={8} className="label-values">
            <span>
            {isAddActivity 
              ? (itemRecord['details']&&itemRecord['details']['sfr'])||"NA" 
              : (itemRecord['Detail']&&itemRecord['Detail']['sfr'])||"NA"}
            </span>
        </Col> 

        <Col span={24} ><span><br /></span></Col>
        
        </Row>
        {/* <br /> */}
        <Row className="ie-criteria-selector">
        <Col span={24}>
        <div className="header">
            <div className="criteria"></div>
            <div className="history">
            <div className="top">Historical value</div>
            <div className="bottom">
            <Button 
            style={{marginTop: 5}}
            size="small"
            onClick={onCopyToMyModifier}
            >
                Copy historical data to my modifiers
            </Button>
            </div>
            </div>
            <div className="modifier">
            My modifiers
            </div>
        </div>
        <Table 
            className='new-entity-table'
            columns={newDetailColumns} 
            dataSource={detailData} 
            pagination={false}
            showHeader={false}
            components={{
                body: {
                    row: EditableDetailRow,
                    cell: EditableDetailCell,
                },
                }}
            />
        </Col>
        </Row>
        
        <Row style={{justifyContent: 'right', paddingTop: '5px'}}>
        <Button className="cancel-btn" 
        onClick={handleNewCancel}
        >
            Cancel
        </Button>
        <Button className="create-btn" 
        onClick={(e) => handleSubmitActivity(e, itemRecord)}
        >
            Submit
        </Button>
        </Row>
    </Modal>)
}

export default IEDetailsModal;